import { api } from "api/axiosConfig";

export const checkTokenValidity = async () => {
  try {
    const { data } = await api.get("/login/validar-token");
    if (data?.valid) {
      return {
        valid: true,
        user: data.user || null,
        empresa: data.empresa || null,
      };
    }
    return {
      valid: false,
      reason: data?.reason || "invalid",
    };
  } catch (error) {
    console.error("Erro ao validar token:", error);
    return {
      valid: false,
      reason: "error",
      error,
    };
  }
};

export const fetchEntitlements = async () => {
  try {
    const { data } = await api.get("/entitlements");
    if (data?.success) return data.data;
    return null;
  } catch (e) {
    console.error("Erro ao carregar entitlements:", e);
    return null;
  }
};
